




























import { computed, defineComponent } from "@vue/composition-api";
import {
  CreatorService,
  CreatorServicePurchaseNotificationDetails,
  isCreatorServicePurchaseNotificationDetails,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { formatMoneyString } from "@/lib/moneyHelpers";
import BaseImage from "@/components/BaseImage";
import FormatMoney from "@/components/FormatMoney";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationCreatorServicePurchase",
  components: { ScreenNamePrinter, NotificationItemView, FormatMoney, BaseImage },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const details = computed<CreatorServicePurchaseNotificationDetails | null>(() =>
      isCreatorServicePurchaseNotificationDetails(props.notification.details) ? props.notification.details : null
    );

    const item = computed<CreatorService | null>(() =>
      details.value?.creatorService ? details.value.creatorService : null
    );

    const previewSrc = computed(() =>
      item.value?.preview ? MediaFilesController.getImageThumbnail(item.value.preview.urlPart, 100) : null
    );
    const price = computed(() => formatMoneyString(item.value?.price ?? 0));
    const messageType = computed(() => {
      return props.notification.type === NotificationType.CREATOR_SERVICE_PURCHASED_CONSUMER
        ? "creatorServicePurchasedConsumer"
        : "creatorServicePurchasedProvider";
    });

    return {
      item,
      previewSrc,
      price,
      messageType,
    };
  },
});
